import React from 'react'
import styled from 'styled-components'

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 180px);
  flex-direction: column;
  gap: 16px;
`

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid ${({ theme }) => theme.listText || '#e0e0e0'};
  border-top-color: ${({ theme }) => theme.primary || '#4a90d9'};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`

const LoadingText = styled.p`
  color: ${({ theme }) => theme.listText || '#666'};
  font-size: 14px;
`

export const MessagingLoading: React.FC = () => (
  <LoadingContainer>
    <Spinner />
    <LoadingText>Connecting to team messaging...</LoadingText>
  </LoadingContainer>
)
